import { render, staticRenderFns } from "./ModalDeleteUser.vue?vue&type=template&id=0ba7832c&scoped=true"
import script from "./ModalDeleteUser.vue?vue&type=script&lang=js"
export * from "./ModalDeleteUser.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteUser.vue?vue&type=style&index=0&id=0ba7832c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba7832c",
  null
  
)

export default component.exports